import {
  CellAlignment,
  FileDescriptor,
  ImageShapeDescriptor,
  TextConfig,
  TextShapeDescriptor,
} from '../../../../../elements/resource/types/shape.type';
import { RectangleController } from '../../../../../elements/util/rectangle-controller/rectangle-controller';
import { setHoveredShape } from '../../../../store/editor.actions';
import { selectHoveredShape } from '../../../../store/selector/editor.selector';
import { TextShape } from '../../text/text-shape';
import { FileRootShape } from './file-root-shape';
import { UploadedImage } from '../../../../../project-overview/image-upload-modal/image-upload-modal.component';
import { ImageShape } from '../../base/image-shape';
import gsap from 'gsap';
import { Container } from 'pixi.js';
export type ShapeCellState = 'hidden' | 'preview' | 'active';

export type ContainerAnimationId = 'static' | 'slide-up' | 'on-by-one';

export interface ContainerAnimationDescriptor {
  id: ContainerAnimationId;
  duration?: number;
}

export class ShapeCell {
  rc: RectangleController;
  ts: TextShape;

  imageShape: ImageShape;
  state: ShapeCellState = 'hidden';

  get cs() {
    return this.shape.cs;
  }
  get isContentDefined() {
    if (!this.content) {
      return false;
    }
    if (this.content.text && this.content.text != 'undefined') {
      return true;
    }

    if (this.content.imageUrl && this.content.imageUrl != 'undefined') {
      return true;
    }

    if (this.content.videoUrl && this.content.videoUrl != 'undefined') {
      return true;
    }

    return false;
  }

  container: Container;

  constructor(
    private readonly shape: FileRootShape,
    private readonly id: string,
    public readonly cell: CellAlignment,
    private content: {
      text?: string;
      textConfig?: Partial<TextConfig>;
      imageUrl?: string;
      videoUrl?: string;
    },
  ) {
    // -- // -- //
    this.init();
    this.setState('preview');
  }

  get width() {
    return this.cell.w * this.shape.newCellAlignment.w;
  }

  get height() {
    return this.cell.h * this.shape.newCellAlignment.h;
  }

  init() {
    const { w: W, h: H } = this.shape.newCellAlignment;
    const { x, y, w, h } = this.cell;

    this.container = new Container();
    this.shape.container.addChild(this.container);

    this.container.x = x * W;
    this.container.y = y * H;

    // console.log('init-cell', this.cell);
    // console.log({ X, Y, W, H, x, y, w, h });
    const id = Math.random().toString();

    const width = w * W;
    const height = h * H;
    this.rc = new RectangleController(
      this.shape,
      {
        id,
        width,
        height,
        // offset: [x * W, y * H],
        // noFill: true, //
        skipPCs: true,
        noStroke: true,
        fill: true,

        startDrag: () => {
          // this.shape.startDrag(); //
        },
        drag: () => {},
        endDrag: () => {
          this.shape.endDrag();
        },
        clicked: () => {
          this.shape.cs.generalEventEmit('text-cell-edit', {
            id: this.id,
            text: this.content.text,
          });
          const sub = this.shape.cs.generalEventSubscribe(
            'text-cell-edit-saved',
            (result: {
              id: string;
              text?: string;
              textConfig?: Partial<TextConfig>;
            }) => {
              // We will come back here by any means
              sub.unsubscribe();
              if (!result) {
                return;
              }

              if (result.id != this.id) {
                return;
              }

              const { id } = result;

              if (result.text !== undefined) {
                const text = result.text;
                this.shape.content[id].text = text;
                this.ts.updateText(text);
              }

              // Apply textConfig changes (fontSize, widthRatio, align)
              const cfg = result.textConfig;

              if (cfg) {
                this.shape.content[id].textConfig = {
                  ...(this.shape.content[id].textConfig || {}),
                  ...cfg,
                };

                const widthRatio = cfg.widthRatio;
                if (widthRatio !== undefined) {
                  this.alignTs(this.ts, widthRatio, cfg.align);
                } else {
                  this.alignTs(this.ts, undefined, cfg.align);
                }
              }

              this.shape.saveDescriptorKey('content', this.shape.content, true);
              this.ts.updateText();
            },
          );
          // console.log('--------- clicked ----------');
        },
        mouseover: () => {
          // console.log('-------cell--------rc > mouseover'); //
          // Set this cell to active state //

          this.shape.store.dispatch(setHoveredShape({ IRI: id }));
        },
        mouseout: () => {
          // console.log('------cell---------rc > mouseout'); //
          // Set all cells back to hidden state
        },
        onTextIconClick: () => {
          console.log('-----on-text-icon-click ------');

          this.shape.cs.generalEventEmit('text-cell-edit', {
            id: this.id,
            text: this.content?.text,
          });

          const sub = this.cs.generalEventSubscribe(
            'text-cell-edit-saved',
            (result: {
              id: string;
              text?: string;
              textConfig?: Partial<TextConfig>;
            }) => {
              console.log('text-is-saved', result);

              sub.unsubscribe();
              // -- //
              if (!result) {
                return;
              }
              if (result.id != this.id) {
                return;
              }

              const initTextElement = !this.content?.text;

              const textValue =
                result.text !== undefined
                  ? result.text
                  : this.content?.text || '';

              const { id } = result;
              this.content = { text: textValue };
              this.shape.content ||= {};
              this.shape.content[id] = {
                text: textValue,
              };

              // Save text update
              this.shape.saveDescriptorKey('content', this.shape.content, true);

              // Apply textConfig changes (fontSize, widthRatio, align)
              const cfg = result.textConfig || {};
              if (Object.keys(cfg).length) {
                this.shape.content[id].textConfig = {
                  ...(this.shape.content[id].textConfig || {}),
                  ...cfg,
                };
              }

              const widthRatio = cfg.widthRatio;
              const align = cfg.align;

              this.ts?.remove();
              // -- // -- //
              this.initContentElements().then(() => {
                this.refreshThumbnail();
                this.ts.updateText(textValue);
                if (widthRatio !== undefined || align !== undefined) {
                  this.alignTs(this.ts, widthRatio, align);
                } else {
                  this.alignTs(this.ts);
                }
              });

              // -- // -- //
              // if (!this.content.text) {
              //   this.initContentElements();
              // }

              this.save();
            },
          );
          // -- //
          // this.shape.addText();
        },
        onImageIconClick: () => {
          console.log('on-image-icon-click');
          // Emit event to open image upload modal
          this.shape.cs.generalEventEmit('image-cell-upload', {
            id: this.id,
          });

          // Subscribe to the upload result
          const sub = this.shape.cs.generalEventSubscribe(
            'image-cell-upload-saved',
            (result: { id: string; image: UploadedImage }) => {
              // Unsubscribe after receiving the result
              sub.unsubscribe();

              if (!result) {
                return;
              }

              if (result.id !== this.id) {
                return;
              }

              const { id, image } = result;
              console.log('image-cell-upload-saved', { id, image });

              // Store the image URL in the content

              const imageId = image.id;

              this.content = { imageUrl: imageId };
              this.shape.content[this.id] ||= {};
              this.shape.content[this.id].imageUrl = imageId;
              // Save to descriptor
              this.shape.saveDescriptorKey('content', this.shape.content, true);

              // this.shape.uploadFile(imageId, image.file);

              this.imageShape?.remove();
              this.initContentElements().then(() => {
                // -- // -- // -- //
                this.refreshThumbnail();
              });

              // TODO: Upload to S3 and update with permanent URL
              // For now, we're using the preview data URL

              // Hide the shape icons since content is now defined
              this.rc.hideShapeIcons();
            },
          );
        },
        onAnimatedImagesIconClick: () => {
          console.log('on-animated-images-icon-click');
          // this.shape.addAnimatedImage();
        },
      },
      this.container,
      this.container,
    );

    this.rc.rect.patch({
      stroke: '#ffffff',
      'stroke-width': 0,
    });

    this.shape.store.select(selectHoveredShape).subscribe(IRI => {
      if (IRI == id) {
        this.setState('active');
        // Set all other cells to preview state
        Object.values(this.shape.shapeCells).forEach(cell => {
          if (cell.id !== this.id) {
            cell.setState('preview');
          }
        });
      } else {
        this.setState('preview');
        setTimeout(() => {
          const shapeCells = Object.values(this.shape.shapeCells);

          if (!shapeCells.find(cell => cell.state == 'active')) {
            // console.log('noo-active was found');
            Object.values(this.shape.shapeCells).forEach(cell => {
              cell.setState('hidden');
            });
            return;
          }
        }, 1);
      }
    });

    if (!this.content) {
      return;
    }

    this.initContentElements();
    // -- // -- //

    this.rc?.show();

    if (!this.isContentDefined) {
      this.rc.showShapeIcons();
    }
    // Initialize in hidden state //
    // this.setState('hidden');   //
  }

  refreshThumbnail() {
    this.shape.cs.setThumbnailByRootShape(this.shape);
  }

  async initContentElements() {
    const { x: X, y: Y, w: W, h: H } = this.shape.newCellAlignment;
    const { x, y, w, h } = this.cell;
    const { text, imageUrl, textConfig } = this.content;
    // -- //

    // console.log('initContnet', this.content); //
    await new Promise(resolve => {
      if (text) {
        // console.log('initTextShape', text); //
        this.ts = new TextShape(
          this.shape.service,
          {
            IRI: `#ts-${this.shape.IRI}`,
            literals: {
              label: 'text-shape',
              descriptor: {
                type: 'text-shape',
                position: {
                  x: 0,
                  y: 0,
                },
                // cellAlignment: {
                //   w: w * W,
                //   widthRatio: 0.3,
                //   h: h * H,
                //   x: X + x,
                //   y: Y + y,
                //   align: 'center',
                // },
                svgAttributes: {
                  fill: {
                    color: this.isImageShape ? '#ffffff' : '#ffffff',
                  },
                },
                text,
                textConfig: {
                  text,
                  fontSize: 28,
                  // fontFamily: 'Plus Jakarta Sans',
                  fontFamily: 'Goldman',
                  align: 'center',
                  ...textConfig,
                },
              } as TextShapeDescriptor,
            },
            relationships: {
              file: this.shape.IRI,
              parent: this.shape.IRI,
            },
          },
          {
            cellKey: this.id,
            resolve,
            wordDisplayLevel:
              (this.shape.descriptor as FileDescriptor).textAnimation?.line
                ?.type == 'fade'
                ? 'letter'
                : undefined,
          },
        );
        this.ts.afterInit();

        this.alignTs(this.ts);

        this.container.addChild(this.ts.container);
        this.shape._shapes.push(this.ts);
      }

      if (imageUrl) {
        if (imageUrl == 'undefined') {
          // -- //
          this.rc.showShapeIcons();
          return;
        } else {
          this.imageShape = new ImageShape(
            this.shape.service,
            {
              IRI: `#image-${this.shape.IRI}`,
              literals: {
                label: 'image-shape',
                descriptor: {
                  type: 'image-shape',
                  position: {
                    x: 0,
                    y: 0,
                  },
                  cellAlignment: {
                    w: w * W,
                    widthRatio: 0.7,
                    h: h * H,
                    x: 0,
                    y: 0,
                    align: 'center',
                  },

                  s3Id: imageUrl,
                } as ImageShapeDescriptor,
              },
              relationships: {
                file: this.shape.IRI,
                parent: this.shape.IRI,
              },
            },
            {
              cellKey: this.id,
              resolve,
            },
          );

          this.container.addChild(this.imageShape.container);
          this.imageShape.afterInit();
          this.shape._shapes.push(this.imageShape);
        }
        // init-image
      }
    });
  }

  save() {
    this.shape.saveDescriptorKey('content', this.shape.content, true);
  }

  realignTs() {
    this.alignTs(this.ts);
  }

  get isImageShape() {
    return (
      this.shape.IRI ==
      'http://nowords.com#5f7f8380-c452-11f0-961f-7114782dc989'
    );
  }

  alignTs(
    textShape: TextShape,
    widthRatio = 0.8,
    align?: 'left' | 'center' | 'right' | 'justify',
  ) {
    // -- // -- //
    const { x: X, y: Y, w: W, h: H } = this.shape.newCellAlignment;
    const { x, y, w, h } = this.cell;

    widthRatio ||= this.isImageShape ? 0.45 : 0.8;
    //

    const effectiveAlign =
      align || this.ts?.descriptor?.textConfig?.align || 'center';

    textShape.doAlign({
      w: w * W,
      widthRatio,
      h: h * H,
      x: 0,
      y: 0,
      // x: X + x, //
      // y: Y + y, //
      align: effectiveAlign === 'justify' ? 'center' : (effectiveAlign as any),
    });

    const [_w, _h] = textShape.dim;

    switch (this.cell.align) {
      case 'center':
      default:
        // textShape.translate.x = X + x + (w * W - _w) / 2;
        // textShape.translate.y = Y + y + (h * H - _h) / 2;
        // textShape.applyTranslate(textShape.translate);
        break;
    }
  }

  setState(newState: ShapeCellState) {
    this.state = newState;
    // console.log('setState', newState);
    switch (newState) {
      case 'hidden':
        // Hide outline and shapeIcons
        this.rc.rect.patch({
          'stroke-width': 0,
        });
        this.rc.hideShapeIcons();
        break;

      case 'preview':
        // Show outline at 0.75px, hide shapeIcons
        this.rc.rect.patch({
          'stroke-width': 0.75,
        });
        this.rc.hideShapeIcons();
        break;

      case 'active':
        // Show outline at 1.5px, show shapeIcons
        this.rc.rect.patch({
          'stroke-width': 1.5,
        });
        if (!this.isContentDefined) {
          this.rc.showShapeIcons();
        }
        break;
    }
  }

  remove() {
    console.log('shape-cell > remove');
    this.rc?.remove();
    this.ts?.remove({ noSave: true });
    this.imageShape?.remove({ noSave: true });
  }

  gsapAnimate(start: number, end: number) {
    if (this.ts) {
      return this.ts.gsapAnimateNew(null);
    }
    return gsap.timeline();
  }

  appearAnimation(numberOfCells: number, index?: number) {
    const timeline = gsap.timeline();

    // Based on the number I need to calculate

    // const duration = 1;
    // const delay = 0.5;
    // const stagger = 0.2;

    // // const
    // // -- // -- // -- // -- // -- // -- //

    // // const topology = this.shape.descriptor.topology;

    // const topology = 'row' as 'row' | 'column';

    // switch (topology) {
    //   case 'row':
    //     // We assume each cell has the same dimension
    //     const width = this.width;
    //     const height = this.height;

    //     // -- //
    //     break;
    //   case 'column':
    //     break;
    // }

    const container = this.ts?.container || this.imageShape?.container;

    if (!container) {
      return timeline;
    }

    timeline.add(
      gsap.from(container, {
        duration: 0.7,
        alpha: 0,
        ease: 'power1.inOut',
        stagger: 0.2,
      }),
    );
    timeline.add(
      gsap.from(container, {
        duration: 1,
        x: (i, target) => {
          return target.x - 50;
        },
        ease: 'power1.inOut',
      }),
      0,
    );

    // timeline.from(this.rc.rect, {
    //   duration,
    //   delay,
    //   alpha: 0,
    //   ease: 'power1.inOut',
    //   stagger,
    // });

    return timeline;
  }
}
